export const certificationExamResults = {
    pendingResult: 'PENDING'
};
